import { createSlice } from '@reduxjs/toolkit';

// utils
import { getDispatch } from '../dispatchHelper';

// ----------------------------------------------------------------------

type ControlCodeState = {
  controlCode: string;
};

const initialState: ControlCodeState = {
  controlCode: '',
};

const slice = createSlice({
  name: 'controlCode',
  initialState,
  reducers: {
    clearState(state) {
      state.controlCode = initialState.controlCode;
    },

    setControlCode(state, action) {
      state.controlCode = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export function clearControlCode() {
  getDispatch()(slice.actions.clearState());
}

export function setControlCode(controlCode: string) {
  if (!controlCode) {
    return;
  }

  getDispatch()(slice.actions.setControlCode(controlCode));
}
